import JhandiMundaGame from './JhandiMundaGame';

function App() {
  return (
    <div className="App">
      <JhandiMundaGame />
    </div>
  );
}

export default App;